import { gql } from '@apollo/client';
const UPDATE_PRODUCT_SUSTAINABILITY = gql `
  mutation UpdateProductSustainability(
    $productSustainabilityId: ID!
    $name: String!
    $description: String
    $thumbnail: String
  ) {
    updateProductSustainability(
      productSustainabilityId: $productSustainabilityId
      name: $name
      description: $description
      thumbnail: $thumbnail
    ) {
      productSustainability {
        id
        name
        description
        thumbnail
      }
    }
  }
`;
export default UPDATE_PRODUCT_SUSTAINABILITY;
